/** @format */

import styled from 'styled-components';
import { cssVars } from '../../GlobalStyles';

const StyledTagClear = styled.span`
  cursor: pointer;
  margin-left: 4px;

  :hover {
    color: ${cssVars.red};
  }
`;

export default StyledTagClear;
